if (!customElements.get('wls-logo-slider')) {
    class WLSLogoSlider extends HTMLElement {
        constructor() {
            super();

            this.classes = {
                slider: 'js-wls-logo-slider',
                slide: 'splide__slide',
                splideClass: 'splide',
            };

            this.elements = {
                slides: this.querySelectorAll(`.${this.classes.slide}`),
                slider: this.querySelector(`.${this.classes.slider}`)
            };

            document.addEventListener("DOMContentLoaded", this.initialize.bind(this));
        }

        initialize() {
            if (this) {
                this.initSlider(this.elements.slider);
            }
        }


        initSlider(slider) {
            const slideCount = this.elements.slides.length;
            const isMobile = window.innerWidth <= 1024;

            if (slideCount <= 1) {
                if (slider.splide) {
                    slider.splide.destroy();
                }

                slider.classList.remove(this.classes.splideClass);
                if (this.elements.slides.length > 0) {
                    this.elements.slides.forEach((slide) => {
                        slide.classList.remove(this.classes.splideSlideClass);
                    });
                }
            } else if (slideCount > 1) {
                const logoSlider = new Splide(slider, {
                    perPage: isMobile ? 1 : 4,
                    perMove: 1,
                    type: "loop",
                    focus: "left",
                    autoWidth: true,
                    arrows: false,
                    pagination: false,
                    gap: "6.4rem",
                    autoplay: true,
                    //interval: 3000,
                    //drag: true,
                });

                if (slider.splide) {
                    slider.splide.destroy();
                }

                slider.splide = logoSlider;
                logoSlider.mount();
            }
        }
    }
    window.customElements.define('wls-logo-slider', WLSLogoSlider);
}

